export default __webpack_public_path__ + "static/media/nqphn-logo.363a827c.svg";